'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouterRedux = require('react-router-redux');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reduxAsyncConnect = require('redux-async-connect');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _auth = require('redux/modules/auth');

var _reactGateway = require('react-gateway');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;

    var promises = [];

    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    routing: state.routing,
    meta: state.meta,
    auth: state.auth
  };
}, { pushState: _reactRouterRedux.push }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App(props) {
    (0, _classCallCheck3.default)(this, App);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(App).call(this, props));

    _this.state = {
      displayMobileMenu: false,
      displayDesktopMenu: false
    };
    return _this;
  }

  (0, _createClass3.default)(App, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { location: this.props.location, history: this.props.history, routing: this.props.routing };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var meta = _props.meta;
      var auth = _props.auth;

      var styles = require('./App.scss');
      var links = [{ 'rel': 'stylesheet', 'href': 'https://fonts.googleapis.com/css?family=Libre+Baskerville:400,700', type: 'text/css' }];
      var pathname = this.props.location.pathname;
      var redirect_uri = _config2.default.instagramRedirectURL;
      console.log('PATH=' + pathname);
      if (pathname.indexOf('/@') == 0) {
        links.push({ 'rel': 'canonical', href: 'http://outfeats.com/u' + this.props.location.pathname });
      } else if (pathname.indexOf('/o/') == -1 && pathname.indexOf('create') == -1 && pathname.indexOf('discover') == -1) {
        links.push({ 'rel': 'canonical', href: 'http://outfeats.com/o' + this.props.location.pathname });
      }
      return _react2.default.createElement(
        _reactGateway.GatewayProvider,
        null,
        _react2.default.createElement(
          'div',
          { className: styles.app },
          _react2.default.createElement(_reactHelmet2.default, (0, _extends3.default)({}, meta, {
            link: links,
            script: [{ 'src': 'https://use.typekit.net/sde2cli.js', 'type': 'text/javascript' }]
          })),
          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: '<script>try{Typekit.load({ async: true });}catch(e){}</script>' } }),
          _react2.default.createElement(
            'div',
            { className: 'hide-small' },
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)(styles.navbar) },
              _react2.default.createElement(
                'h1',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '' },
                  'Outfeats.'
                )
              ),
              _react2.default.createElement(
                'ul',
                { className: (0, _classnames2.default)((0, _defineProperty3.default)({}, styles.isDisplayed, this.state.displayDesktopMenu)) },
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: 'discover', activeClassName: styles.active },
                    'Discover'
                  ),
                  ' ',
                  _react2.default.createElement('span', { className: styles.dash })
                ),
                !auth.user || !auth.user.id && _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: 'https://www.instagram.com/oauth/authorize/?client_id=432f7984e8374318b15c9687588f4f74&redirect_uri=' + redirect_uri + '?from=' + pathname + '&response_type=code' },
                    'Connect'
                  ),
                  ' ',
                  _react2.default.createElement('span', { className: styles.dash })
                ),
                auth.user && auth.user.id && _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '@' + auth.user.username, activeClassName: styles.active },
                    'Profile'
                  ),
                  _react2.default.createElement('span', { className: styles.dash })
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: 'create', className: styles.create },
                    'Create your outfeat'
                  ),
                  ' ',
                  _react2.default.createElement('span', { className: styles.dash })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(styles.navBtn, 'display-small'), onClick: function onClick() {
                return _this2.setState({ displayMobileMenu: true });
              } },
            _react2.default.createElement('div', null)
          ),
          _react2.default.createElement(
            'div',
            { className: styles.appContent },
            this.props.children
          ),
          _react2.default.createElement(
            'div',
            { onClick: function onClick() {
                return _this2.setState({ displayMobileMenu: false });
              }, className: (0, _classnames2.default)(styles.mobileMenu, (0, _defineProperty3.default)({}, styles.isDisplayed, this.state.displayMobileMenu)) },
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: 'create', activeClassName: styles.active },
                  'Create'
                ),
                ' ',
                _react2.default.createElement('span', { className: styles.dash })
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: 'discover', activeClassName: styles.active },
                  'Discover'
                ),
                ' ',
                _react2.default.createElement('span', { className: styles.dash })
              ),
              !auth.user || !auth.user.id && _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: 'https://www.instagram.com/oauth/authorize/?client_id=432f7984e8374318b15c9687588f4f74&redirect_uri=' + redirect_uri + '?from=' + pathname + '&response_type=code' },
                  'Connect with Instagram'
                ),
                ' ',
                _react2.default.createElement('span', { className: styles.dash })
              ),
              auth.user && auth.user.id && _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '@' + auth.user.username, activeClassName: styles.active },
                  'Profile'
                ),
                _react2.default.createElement('span', { className: styles.dash })
              )
            )
          ),
          _react2.default.createElement(_reactGateway.GatewayDest, { name: 'modal', className: styles.modalContainer })
        )
      );
    }
  }]);
  return App;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.object.isRequired,
  pushState: _react.PropTypes.func.isRequired,
  meta: _react.PropTypes.object.isRequired
}, _class2.contextTypes = {
  store: _react.PropTypes.object.isRequired
}, _class2.childContextTypes = {
  location: _react2.default.PropTypes.object,
  history: _react2.default.PropTypes.object,
  routing: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = App;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App/App.js
 ** module id = 1107
 ** module chunks = 0
 **/